// angular imports
import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';

// devextreme imports
import { DxDataGridComponent, DxPopupComponent } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';

// cc-common imports
import { Utils } from 'cc-common';

// component imports
import { WorkOrderBaseComponent } from '../../../_base/work-order-base-component';

// model imports
import { WorkOrderVendorProposalFileInfoRawDto } from '../../../_models/work-order-vendor-proposal-file-info-raw-dto';
import { WorkOrderProposalAcceptParametersDto } from '../../../_models/work-order-proposal-accept-parameters-dto';

// constant imports
import { MessageInterval } from '../../../../_constants/messages-intervals';

@Component({
    selector: 'app-propsal-accept-editor',
    templateUrl: './propsal-accept-editor.component.html',
    styleUrls: ['./propsal-accept-editor.component.scss']
})
export class PropsalAcceptEditorComponent extends WorkOrderBaseComponent implements OnInit {
    @ViewChild('proposalAcceptedEditorPopup', { static: false }) proposalAcceptedEditorPopup: DxPopupComponent;
    @ViewChild('quotesGrid', { static: false }) quotesGrid: DxDataGridComponent;

    @Input() communityId: number;
    @Input() workOrderId: number;
    @Input() workOrderProposalId: number;
    @Input() quotesList: Array<WorkOrderVendorProposalFileInfoRawDto> = [];

    @Output() onClose = new EventEmitter<void>();

    visible = false;
    selectedRowKeys: Array<number> = [];

    constructor(protected readonly injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        this.show();
    }

    show(): void {
        this.visible = true;
    }

    onPopupShown(): void {
        this.proposalAcceptedEditorPopup.instance.repaint();
    }

    onPopupClose(): void {
        this.closeAcceptedEditorProposals();
    }

    onContentReady(e: any): void {
        const selectedKeys = this.quotesList.filter((d) => Utils.isTrue(d.isAccepted)).map((m) => m.fileId);
        if (Utils.notNullOrEmpty(selectedKeys)) {
            this.quotesGrid.instance.selectRows(selectedKeys, false);
        }
    }

    onGridSelectionChanged(event: any): void {
        const selectedRowKeys = event.selectedRowKeys;

        this.quotesList.forEach((quote) => {
            const selectedQuote = selectedRowKeys.find((d) => Utils.equals(d, quote.fileId));
            if (Utils.notNullAndDefined(selectedQuote)) {
                quote.isAccepted = true;
            } else {
                quote.isAccepted = false;
            }
        });
    }

    onSaveClick(): void {
        const baseParams: WorkOrderProposalAcceptParametersDto = new WorkOrderProposalAcceptParametersDto();
        baseParams.communityId = this.communityId;
        baseParams.workOrderId = this.workOrderId;
        baseParams.workOrderProposalId = this.workOrderProposalId;
        baseParams.acceptedFileIds = this.quotesList.filter((d) => Utils.isTrue(d.isAccepted)).map((m) => m.fileId);

        this.workOrderHelperService.showLoading();
        this.workOrderService.acceptWorkOrderProposal(baseParams).subscribe(
            () => {
                notify('Quotes accepted successfully.', 'Success', MessageInterval.successMsgInterval);
                this.closeAcceptedEditorProposals();
                this.workOrderHelperService.hideLoading();
            },
            (error) => {
                this.errorService.displayError(error);
                this.workOrderHelperService.hideLoading();
            }
        );
    }

    private closeAcceptedEditorProposals(): void {
        this.visible = false;
        this.onClose.emit();
    }
}
